(function () {
  // 1. Safely initialize Ketch command queue
  window.ketch = window.ketch || function () {
    (window.ketch.q = window.ketch.q || []).push(arguments);
  };

  // 2. Style rule: keeps Attentive rendered so it doesn't trigger a session dismissal
  const hideAttentiveCSS = `
    #attentive_overlay,
    #attentive_creative,
    iframe[src*="attn.tv"] {
      opacity: 0 !important;
      pointer-events: none !important;
      z-index: -1 !important;
      visibility: hidden !important;
    }
  `;

  function setAttentiveVisibility(hide) {
    let styleTag = document.getElementById('hide-attentive-style');
    if (hide) {
      if (!styleTag) {
        styleTag = document.createElement('style');
        styleTag.id = 'hide-attentive-style';
        styleTag.innerHTML = hideAttentiveCSS;
        document.head.appendChild(styleTag);
      }
    } else if (styleTag) {
      styleTag.remove();
    }
  }

  // 3. Listen to Ketch lifecycle events
  ['showExperience', 'showConsentExperience', 'showPreferenceExperience'].forEach(function (evt) {
    window.ketch('on', evt, function () {
      setAttentiveVisibility(true);
    });
  });

  ['hideExperience', 'hideConsentExperience', 'hidePreferenceExperience'].forEach(function (evt) {
    window.ketch('on', evt, function () {
      setAttentiveVisibility(false);
    });
  });

  // 4. Reveal consent links when Ketch initializes
  function revealConsentLinks() {
    document.querySelectorAll('.consent-link').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function checkKetch() {
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (typeof window.ketch === 'function' && window.ketch.hasConsent) {
        clearInterval(interval);
        revealConsentLinks();
      } else if (attempts > 50) {
        clearInterval(interval);
        revealConsentLinks();
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkKetch);
  } else {
    checkKetch();
  }
})();